import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type FulfillmentMode = 'delivery' | 'pickup';

const FULFILLMENT_MODE_KEY = 'fulfillment-mode';

interface FulfillmentState {
  mode: FulfillmentMode;
}

const initialState: FulfillmentState = {
  // Самовывоз отключён в UI, поэтому сохранённый в localStorage 'pickup' больше
  // не восстанавливаем — иначе корзина залипала бы в режиме самовывоза без
  // единого способа переключиться обратно. Вернуть вместе с табами.
  mode: 'delivery',
  // mode:
  //   localStorage.getItem(FULFILLMENT_MODE_KEY) === 'pickup'
  //     ? 'pickup'
  //     : 'delivery',
};

export const fulfillmentSlice = createSlice({
  name: 'fulfillment',
  initialState,
  reducers: {
    setFulfillmentMode: (state, action: PayloadAction<FulfillmentMode>) => {
      state.mode = action.payload;
      localStorage.setItem(FULFILLMENT_MODE_KEY, action.payload);
    },
  },
});

export const { setFulfillmentMode } = fulfillmentSlice.actions;
export default fulfillmentSlice.reducer;
